import { render, staticRenderFns } from "./HeadphonesLoader.vue?vue&type=template&id=2f0edf48&"
import script from "./HeadphonesLoader.vue?vue&type=script&lang=js&"
export * from "./HeadphonesLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0edf48')) {
      api.createRecord('2f0edf48', component.options)
    } else {
      api.reload('2f0edf48', component.options)
    }
    module.hot.accept("./HeadphonesLoader.vue?vue&type=template&id=2f0edf48&", function () {
      api.rerender('2f0edf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeadphonesLoader.vue"
export default component.exports